import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { isAddress } from 'web3-utils'

export const init = (vue) => {
  extend('required', required)

  extend('address', {
    validate: (value) => {
      return isAddress(value)
    },
    message:
      'The value is not an address'
  })

  vue.component('ValidationProvider', ValidationProvider)
  vue.component('ValidationObserver', ValidationObserver)
}
